module.exports = __webpack_public_path__ + "static/media/clay.975ae7ff.jpg";